import { STM } from '../context/types';

export const hu_huStatements :  STM[]= [
  {
    "id":1,
    "valueKey": "samen1",
    "title":"a közös munka gyakori",
    "title_360_leadership": "közvetlenül stimulálja a csapatmunkát",
    "title_360_workenv": "a közösségi munka gyakori",
    "preferredType": "leadership"
  },
  {
    "id":2,
    "valueKey": "samen2",
    "title":"a csoport érdekek megelőzik az egyéni érdekeket",
    "title_360_leadership": "előnyben részesíti a csapat sikerét a sajátjával szemben",
    "title_360_workenv": "a csapat érdekek a személyes érdekek előtt állnak",
    "preferredType": "workenv"
  },
  {
    "id":3,
    "valueKey": "samen3",
    "title":"az egyén mindent megtesz a csapatért",
    "title_360_leadership": "részt vesz az egyesületében",
    "title_360_workenv": "az ember a csapatért tesz a legjobbat",
    "preferredType": "leadership"
  },
  {
    "id":4,
    "valueKey": "conf1",
    "title":"egy személyes vélemény nem kerül megosztásra, ha az konfliktushoz vezethet",
    "title_360_leadership": " nem nyilatkozik, ha ez konfliktushoz vezethet",
    "title_360_workenv": "a személyes vélemény nem oszlik meg, ha ez konfliktushoz vezethet",
    "preferredType": "workenv"
  },
  {
    "id":5,
    "valueKey": "conf2",
    "title":"minden erőfeszítés megtörténik a béke megőrzése érdekében",
    "title_360_leadership": "mindent megtesz, hogy vitákat elkerüljön",
    "title_360_workenv": "minden erőfeszítést megteszünk a békéért",
    "preferredType": "leadership"
  },
  {
    "id":6,
    "valueKey": "conf3",
    "title":"a fennálló szabályok és szabványok pontosan be vannak tartva",
    "title_360_leadership": "arra figyel, hogy a szabályok és normák betartassanak",
    "title_360_workenv": "a létező szabályok és sztenderdek pontosan betartásra kerülnek",
    "preferredType": "workenv"
  },
  {
    "id":7,
    "valueKey": "erken1",
    "title":"az embereket tisztelik a munkatársak és a menedzserek",
    "title_360_leadership": "garantálja a személyes kölcsönös tiszteletet",
    "title_360_workenv": "a munkatársak és vezetők tiszteletben tartják az embereket",
    "preferredType": "workenv"
  },
  {
    "id":8,
    "valueKey": "erken2",
    "title":"a kemény munkáért elismerés jár",
    "title_360_leadership": "elismeri a munkánkat",
    "title_360_workenv": "a kemény munkáért elismerés jár",
    "preferredType": "workenv"
  },
  {
    "id":9,
    "valueKey": "erken3",
    "title":"az elköteleződésnek értéke van és értékelik",
    "title_360_leadership": "értékeli a teljesített erőfeszítést",
    "title_360_workenv": "a szándékot értékelik és számon tartják",
    "preferredType": "leadership"
  },
  {
    "id":10,
    "valueKey": "zorg1",
    "title":"az egyén mindig a helyes módon viselkedik másokkal",
    "title_360_leadership": "barátságos és tiszteletteljes",
    "title_360_workenv": "az ember mindig másokkal rendben van",
    "preferredType": "leadership"
  },
  {
    "id":11,
    "valueKey": "zorg2",
    "title":"az egyén hozzájárul a mások jólétéhez",
    "title_360_leadership": "előnyben részesíti az atmoszférát, ahol mindenki jól érzi magát",
    "title_360_workenv": "az ember mások jólétét is hozzájárulja",
    "preferredType": "workenv"
  },
  {
    "id":12,
    "valueKey": "zorg3",
    "title":"az emberek segítik egymást",
    "title_360_leadership": "előnyben részesíti a segítségkölcsönzést",
    "title_360_workenv": "az emberek egymásnak segítenek",
    "preferredType": "leadership"
  },
  {
    "id":13,
    "valueKey": "gelijk1",
    "title":"mindenki egyenlő bánásmódban részesül",
    "title_360_leadership": "mindenkit egyenlően kezel",
    "title_360_workenv": "mindenki egyenlően kezelik",
    "preferredType": "workenv"
  },
  {
    "id":14,
    "valueKey": "gelijk2",
    "title":"kor, származás, vagy nem nem számít",
    "title_360_leadership": "nem tesz különbséget kor, eredet vagy nemzetiségi hovatartozás alapján",
    "title_360_workenv": "a kor, eredet vagy nem számít",
    "preferredType": "workenv"
  },
  {
    "id":15,
    "valueKey": "gelijk3",
    "title":"az egyént a cselekedetei, nem a karaktere alapján ítélik meg",
    "title_360_leadership": "értékeli munkánkat alapján",
    "title_360_workenv": "az ember a cselekedetei alapján ítélik meg, nem a személyiségének",
    "preferredType": "leadership"
  },
  {
    "id":16,
    "valueKey": "zelfsturing1",
    "title":"a legtöbb esetben lehetséges, hogy önállóan cselekedj",
    "title_360_leadership": "biztosítja, hogy mindenki nagy részben maga határozza meg, mit csinál",
    "title_360_workenv": "a legtöbb esetben önállóan lehet cselekedni",
    "preferredType": "workenv"
  },
  {
    "id":17,
    "valueKey": "zelfsturing2",
    "title":"az egyén meghatározhatja a saját munkamódszerét",
    "title_360_leadership": "hagy minket, hogy saját munkamódszereket alakítsunk ki",
    "title_360_workenv": "az ember a saját munkamódszereit határozhatja meg",
    "preferredType": "leadership"
  },
  {
    "id":18,
    "valueKey": "zelfsturing3",
    "title":"az egyén maga megtervezheti, hogy miképp végezze a munkáját",
    "title_360_leadership": "nagy részben hagyja, hogy mindenki maga határozza meg a saját időbeosztását",
    "title_360_workenv": "az ember a saját munkáját saját maga tervezheti",
    "preferredType": "workenv"
  },
  {
    "id":19,
    "valueKey": "macht1",
    "title":"Befolyásolni tudom mások viselkedését",
    "title_360_leadership": "befolyásolja a munkámat",
    "preferredType": "leadership"
  },
  {
    "id":20,
    "valueKey": "macht2",
    "title":"Én vagyok az, aki eldönti, hogy mi a teendő",
    "title_360_leadership": "megmondja, mit kell tenni",
    "preferredType": "leadership"
  },
  {
    "id":21,
    "valueKey": "macht3",
    "title":"Én határozom meg, hogy mi történik",
    "title_360_leadership": "határozza meg, mit kell tenni",
    "preferredType": "disabled"
  },
  {
    "id":22,
    "valueKey": "voorspelbaar1",
    "title":"struktúra és rendszeresség van",
    "title_360_leadership": "garantálja a struktúrát és a rendszerességet",
    "title_360_workenv": "struktúra és rendszeresség van",
    "preferredType": "workenv"
  },
  {
    "id":23,
    "valueKey": "voorspelbaar2",
    "title":"a dolgok általában a terveknek megfelelően történnek",
    "title_360_leadership": "biztosítja, hogy a dolgok általában a tervezett módon mennek végbe",
    "title_360_workenv": "a dolgok rendszerint úgy történnek, ahogy terveztük",
    "preferredType": "leadership"
  },
  {
    "id":24,
    "valueKey": "voorspelbaar3",
    "title":"a hagyományos értékek és gondolkodási módok fenntarthatók",
    "title_360_leadership": "garantálja a hagyományos értékek és gondolkodásmódok tiszteletét",
    "title_360_workenv": "a hagyományos értékek és gondolkodásmódok megőrizhetők",
    "preferredType": "workenv"
  },
  {
    "id":25,
    "valueKey": "prestatie1",
    "title":"lehetséges az egyéneknek a legjobb formájukat hozni",
    "title_360_leadership": "bátorít minket, hogy adjuk a legjobbat magunkból",
    "title_360_workenv": "lehetséges a legjobbat tenni",
    "preferredType": "leadership"
  },
  {
    "id":26,
    "valueKey": "prestatie2",
    "title":"az egyén megmutathatja a benne rejlő összes lehetőséget",
    "title_360_leadership": "bátorít minket, hogy mutassuk, mit tudunk",
    "title_360_workenv": "az ember teljes potenciálját megmutathatja",
    "preferredType": "workenv"
  },
  {
    "id":27,
    "valueKey": "prestatie3",
    "title":"az egyén kitűnhet a munkájában",
    "title_360_leadership": "bátorít minket, hogy kiválóan teljesítsünk",
    "title_360_workenv": "az ember a munkájában kiemelkedhet",
    "preferredType": "workenv"
  },
  {
    "id":28,
    "valueKey": "zelfontplooi1",
    "title":"az egyén folyamatosan új dolgokat tanulhat",
    "title_360_leadership": "bátorítja a folyamatos képzést",
    "title_360_workenv": "az ember folyamatosan új dolgokat tanulhat",
    "preferredType": "workenv"
  },
  {
    "id":29,
    "valueKey": "zelfontplooi2",
    "title":"az egyén elmélyítheti a tudását",
    "title_360_leadership": "bátorít minket, hogy fejlesszük a készségeinket",
    "title_360_workenv": "az ember a tudását mélyítheti",
    "preferredType": "leadership"
  },
  {
    "id":30,
    "valueKey": "zelfontplooi3",
    "title":"az egyén folyamatosan tágíthatja a személyes fejlődése határait",
    "title_360_leadership": "segíti mások fejlesztését",
    "title_360_workenv": "az ember személyes fejlődését folyamatosan bővítheti",
    "preferredType": "workenv"
  },
  {
    "id":31,
    "valueKey": "duurzaam1",
    "title":"jó minőségű munka van leadva",
    "title_360_leadership": "biztosítja, hogy a csapat minőségi munkát végezzen",
    "title_360_workenv": "jó minőségű munka kerül kivitelezésre",
    "preferredType": "leadership"
  },
  {
    "id":32,
    "valueKey": "duurzaam2",
    "title":"tisztelik az ügyfeleket és/vagy a többi üzleti szereplőt",
    "title_360_leadership": "bátorítja a csapatot, hogy részesítsen a vevők és más kapcsolatok tiszteletben tartásában",
    "title_360_workenv": "a vevők és/vagy a vállalkozásban részt vevők tiszteletben tartják",
    "preferredType": "workenv"
  },
  {
    "id":33,
    "valueKey": "duurzaam3",
    "title":"az egyén figyelembe veszi az embereket, a biztonságot és a környezetet",
    "title_360_leadership": "biztosítja, hogy figyeljünk az egyéni biztonságra, a biztonságra és a környezetre",
    "title_360_workenv": "az ember a személyeket, biztonságot és környezetet is figyelembe veszi",
    "preferredType": "workenv"
  },
  {
    "id":34,
    "valueKey": "integriteit1",
    "title":"az egyén felelősséget vállal a cselekedeteiért",
    "title_360_leadership": "biztosítja, hogy vállaljuk a cselekedeteink felelősségét",
    "title_360_workenv": "az ember a cselekedeteiért felelősséget vállal",
    "preferredType": "workenv"
  },
  {
    "id":35,
    "valueKey": "integriteit2",
    "title":"az emberek őszinték",
    "title_360_leadership": "őszinte",
    "title_360_workenv": "az emberek őszinték",
    "preferredType": "workenv"
  },
  {
    "id":36,
    "valueKey": "integriteit3",
    "title":"tisztelik a titoktartást",
    "title_360_leadership": "gondosan kezelheti a személyes és bizalmas információkat",
    "title_360_workenv": "a bizalmas információk tiszteletben tartják",
    "preferredType": "leadership"
  },
  {
    "id":37,
    "valueKey": "innovatie1",
    "title":"ki lehet próbálni új dolgokat",
    "title_360_leadership": "bátorít minket, hogy próbáljuk ki új munkamódszereket",
    "title_360_workenv": "új dolgokat kipróbálhatunk",
    "preferredType": "leadership"
  },
  {
    "id":38,
    "valueKey": "innovatie2",
    "title":"az egyénnek sok új tapasztalata van",
    "title_360_leadership": "bátorít minket, hogy szerezd be új tapasztalatokat",
    "title_360_workenv": "sok új élményt szerezhetek",
    "preferredType": "workenv"
  },
  {
    "id":39,
    "valueKey": "innovatie3",
    "title":"lehet kihívásokat keresni",
    "title_360_leadership": "bátorít minket, hogy kereszünk új kihívásokat",
    "title_360_workenv": "kihívásokat kereshetünk",
    "preferredType": "leadership"
  },
  {
    "id":40,
    "valueKey": "daadkracht1",
    "title":"az egyén kezdeményezi a feladatok megoldását",
    "title_360_leadership": "bátorít minket, hogy kezdeményezzünk magunknak feladatokat",
    "title_360_workenv": "az ember a feladatokhoz kezdeményezést vesz",
    "preferredType": "workenv"
  },
  {
    "id":41,
    "valueKey": "daadkracht2",
    "title":"fontos, hogy minden meg legyen téve az eredmények elérése érdekében",
    "title_360_leadership": "biztosítja, hogy a céljaink elérhetők legyenek",
    "title_360_workenv": "a legjobbat kihozni a legfontosabb",
    "preferredType": "leadership"
  },
  {
    "id":42,
    "valueKey": "daadkracht3",
    "title":"minden lehetséges erőfeszítés meg van téve a kitűzött célok elérése érdekében",
    "title_360_leadership": "mindent megtesz, hogy elérjük a céljainkat",
    "title_360_workenv": "minden erőfeszítést megteszünk a kitűzött célok eléréséhez",
    "preferredType": "leadership"
  }
]
export const extra360Hu_HuStatements : Omit<STM, 'title'>[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'döntéseket hoz',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'az egyes csapattagok közötti különbözőségeket tiszteletben tartja és értékeli',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'konstruktív visszajelzést ad',
      preferredType: 'leadership',
    },
]
